export default {

  entityList: (state => (entityType) => {
    let array = state.entities[entityType + 'List'];
    if (Array.isArray(array)) {
      return array.map(id => state.entities[entityType][id]);
    }
  }),

  entity: (state => (entityType, id) => {
    return state.entities[entityType][id];
  }),

  // languages: (state) => state.entities.languages.map(id => state.entities.languages[id]),
  // contactDetailTypes: (state) => state.entities.contactDetailTypes.map(id => state.entities.contactDetailTypes[id]),
  // partnerTypes: (state) => state.entities.partnerTypes.map(id => state.entities.partnerTypes[id]),
  // partnerRelationships: (state) => state.entities.partnerRelationships.map(id => state.entities.partnerRelationships[id]),

  nightMode: (state) => { return state.nightMode },
  isMainMenuActive: (state) => { return state.isMainMenuActive },
  mainMenuMiniVariant: (state) => { return state.mainMenuMiniVariant },
  snackbar: (state) => { return state.snackbar },
  snackbarData: (state) => { return state.snackbarData },
  eventPageLayouts: (state) => { return state.eventPageLayouts },
  eventPageLayout: (state) => { return state.eventPageLayout },
  eventModules: (state) => { return state.eventModules },
  shouldShowMainMenuAutomatically: (state) => { return state.shouldShowMainMenuAutomatically },
  eventsManagers: (state) => {
    let users = Object.values(state.entities.users).filter(item => {
      if (!item.isActive) {
        return false;
      }
      return item.roles.map(item => {
        return item.key;
      }).indexOf('EVENT_MANAGER') !== -1;
    });
    return users;
  },
  insuranceCompanies: (state) => { return state.insuranceCompanies },
  countries: (state) => { return state.countries },
  // contactDetailTypes: (state) => { return state.contactDetailTypes },
};


// WEBPACK FOOTER //
// ./src/store/getters.js